module.exports = __webpack_public_path__ + "img/43@2x.cfac8923.png";